import React from 'react';
import {useQuery} from '@apollo/client';
import Query from '../../components/Query';
import Icon from '../../components/Icon';
import {QUERY_DOC_LIST} from './graphql';
import {Link, useRouteMatch} from 'react-router-dom';

const FORMAT_ICONS = {
  'application/pdf': 'file-pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'file-word',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'file-excel',
};

const DocList = ({materialId}) => {
  const query = useQuery(QUERY_DOC_LIST, {variables: {materialId}});

  return (
    Query(query) || (
      <div className="row g-3">
        {query.data.docList.map(item => (
          <Link
            to={`/docs/${item.id}`}
            key={item.id}
            className="col-12 col-md-6 col-lg-4 col-xl-3 text-decoration-none"
          >
            <div className="bg-white border rounded row align-items-center p-3">
              <div className="col fw-bold">{item.name}</div>
              <div className="col-auto">
                <Icon name="chevron-right" size={16} />
              </div>
            </div>
          </Link>
        ))}
      </div>
    )
  );
};

export default DocList;
